var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("nav-tab-content", [
    _c(
      "h2",
      [
        _c(
          "router-link",
          {
            staticClass: "hover-underline",
            attrs: {
              to: {
                name: "AccountBilling",
              },
            },
          },
          [_vm._v("\n\t\t< Back to your Account Settings")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.hasLoaded
      ? _c("div", [
          _c("h3", { staticClass: "text-center" }, [
            _vm._v("Checking Zoom status..."),
          ]),
          _c("br"),
        ])
      : !_vm.hasPrioritySupport
      ? _c("div", { key: "divNoPrioritySupport" }, [
          _c("h3", { staticClass: "text-center" }, [
            _vm._v("Oops! It looks like you don't have Priority Support."),
          ]),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-6 org-size" }, [
              _c("p", [
                _c("strong", [_vm._v("Priority Support")]),
                _vm._v(
                  " gives you faster responses and exclusive access to our live "
                ),
                _c("strong", [_vm._v("Office Hours Webinar")]),
                _vm._v(" — all for just "),
                _c("strong", [_vm._v("$19.95/year")]),
                _vm._v("."),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("Here’s what you get:")]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n\t\t\t\t\t✨ "),
                _c("strong", [_vm._v("Zoom to the front of the line.")]),
                _vm._v(
                  " When you reach out to our Support Team, your question sparkles its way to the top. No waiting in line behind mortals."
                ),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n\t\t\t\t\t🎤 "),
                _c("strong", [_vm._v("Join live Office Hours.")]),
                _vm._v(
                  " Every Friday at 8pm Eastern, our Support team host a live Zoom session just for Priority Support members. Ask anything — APA, MLA, Turabian, or just “how do I write this without crying?” — and get real-time answers on the spot.\n\t\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "d-grid" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.btnAddPrioritySupport.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\tAdd Priority Support to my Account\n\t\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "ratio ratio-16x9" }, [
                _c("iframe", {
                  attrs: {
                    src: "https://www.youtube.com/embed/ZRvA2Ah1y14",
                    frameborder: "0",
                    allowfullscreen: "",
                    title: "YouTube Video Explaining Priority Support",
                  },
                }),
              ]),
            ]),
          ]),
        ])
      : !_vm.isDayCheck && !_vm.isTimeCheck
      ? _c("div", { key: "divNotTimeYet", staticClass: "pt-2" }, [
          _c("h3", { staticClass: "text-center" }, [
            _vm._v("Hold your highlighters — you're a little early 🦄⏰"),
          ]),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-6 org-size" }, [
              _c("p", [
                _vm._v("Office Hours kicks off "),
                _c("strong", [_vm._v("every ")]),
                _c("strong", [_vm._v("Friday at 8pm ET")]),
                _vm._v(", and you're ahead of the game."),
              ]),
              _vm._v(" "),
              _vm.isShowJoinButtonMessage
                ? _c("p", [
                    _vm._v(
                      "A button to join the Office Hours webinar will appear below when it's showtime."
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Until then, you don't have to wait to get your burning questions answered! Our Support Team is standing by to answer your questions every day until 11pm ET."
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c(
                    "div",
                    { staticClass: "d-grid gap-2" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { to: { name: "ContactSupport" } },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\tDon't wait - contact our Support Team\n\t\t\t\t\t\t\t"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isJoinButtonShown
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-success",
                              attrs: { href: _vm.linkToZoomCall },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\tJoin the Office Hours Webinar\n\t\t\t\t\t\t\t"
                              ),
                            ]
                          )
                        : _c(
                            "a",
                            {
                              staticClass: "btn btn-outline-success",
                              attrs: {
                                href: "https://perrla.myflodesk.com/officehoursreminder",
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\tSign up for a reminder this Friday\n\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "ratio ratio-16x9" }, [
                _c("iframe", {
                  attrs: {
                    src: "https://www.youtube.com/embed/NgowrhO7z_E",
                    frameborder: "0",
                    allow:
                      "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                    allowfullscreen: "",
                    title: "Getting Your Head Around APA",
                  },
                }),
              ]),
            ]),
          ]),
        ])
      : _c("div", [
          _c("h3", { staticClass: "text-center" }, [
            _vm._v("Join the Office Hours Webinar"),
          ]),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "d-grid" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-success",
                    attrs: { href: _vm.linkToZoomCall },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\tJoin the Office Hours Webinar\n\t\t\t\t\t"
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }